<template>
  <div>
    <el-row class="hidden-sm-and-down"
      ><el-col>
        <div class="idiomas hidden-sm-and-down" style="right: 2.2%">
          <el-button type="default" class="idioma" @click="switchLocale('es')">ES</el-button>
          <el-button type="default" style="margin-left: 0px !important" class="idioma" @click="switchLocale('en')">EN</el-button>
        </div></el-col
      ></el-row
    >
    <header class="hero">
      <div class="container">
        <div class="parallax-wrapper hidden-sm-and-down" v-parallax="0.4">
          <video-background :loop="true" :muted="true" :autoplay="true" v-parallax="0.6" :src="require('@/assets/new/video_banner_principal.mp4')" class="principal-video">
          </video-background>
        </div>
        <div class="parallax-wrapper hidden-md-and-up" v-parallax="0.1">
          <video-background :loop="true" :muted="true" :autoplay="true" v-parallax="0.3" :src="require('@/assets/new/video_banner_principal.mp4')" class="principal-video">
          </video-background>
        </div>
        <div class="hero-content hidden-sm-and-down">
          <div data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
            <el-row
              ><el-col :md="24" :sm="24" :xs="24" :offset-md="2" :offset-sm="2"
                ><h1 class="titulo_" v-html="$t('header.titulo')"></h1>
                <p class="subtitulo_" v-html="$t('header.subtitulo1')"></p>
                <p class="subtitulo_" v-html="$t('header.subtitulo2')"></p></el-col
            ></el-row>
          </div>
        </div>
        <div class="hero-text hidden-md-and-up" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
          <el-row class="stylo_padding"
            ><el-col :md="24" :sm="24" :xs="24" :offset-md="2" :offset-sm="2"
              ><h1 class="titulo_" v-html="$t('header.titulo_phone')"></h1>
              <p class="subtitulo_">{{ $t('header.subtitulo1') }} {{ $t('header.subtitulo2') }}</p>
            </el-col></el-row
          >
        </div>
      </div>
    </header>
    <!-- <div class="homevideo hero">
      <el-row
        ><el-col>
          <div class="idiomas hidden-sm-and-down">
            <el-button type="default" class="idioma" @click="switchLocale">ES</el-button>
            <el-button type="default" class="idioma" @click="switchLocale">EN</el-button>
          </div></el-col
        ></el-row
      >
      <div class="parallax-wrapper" v-parallax="0.4">
        <video-background :loop="true" :muted="true" :autoplay="true" v-parallax="0.6" :src="require('@/assets/new/video_banner_principal.mp4')" class="principal-video"> </video-background>
      </div>
      <div data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
        <el-row
          ><el-col :md="24" :sm="24" :xs="24" :offset-md="2" :offset-sm="2"
            ><h1 class="titulo_" v-html="$t('header.titulo')"></h1>
            <p class="subtitulo_" v-html="$t('header.subtitulo1')"></p>
            <p class="subtitulo_" v-html="$t('header.subtitulo2')"></p></el-col
        ></el-row>
      </div>

      <div class="hero-text hidden-md-and-up" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
        <el-row class="stylo_padding"
          ><el-col :md="24" :sm="24" :xs="24" :offset-md="2" :offset-sm="2"
            ><h1 class="titulo_" v-html="$t('header.titulo')"></h1>
            <p class="subtitulo_">{{ $t('header.subtitulo1') }} {{ $t('header.subtitulo2') }}</p>
          </el-col></el-row
        >
      </div>
    </div> -->
  </div>
</template>

<script>
import VideoBackground from 'vue-responsive-video-background-player'
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  components: { 'video-background': VideoBackground },
  data() {
    return {
      index: null,
      videoModal: false,
      media: [{ title: '', description: '', thumb: '', autoplay: true }],
    }
  },
  mounted() {
    AOS.init({
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    })
    this.$nextTick(() => {
      AOS.refresh()
    })
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    },
    switchLocale(tipo) {
      // if (this.$i18n.locale === 'es') {
      this.$i18n.locale = tipo
      // } else {
      // this.$i18n.locale = 'es'
      // }
    },
  },
}
</script>

<style>
.hero {
  position: relative;
  height: calc(90vh - 0px);
  overflow: hidden;
  display: flex;
  align-items: center; /* centra verticalmente */
  min-height: 60vh; /* opcional si no querés 100vh */
  display: flex;
  align-items: center;
  /* justify-content: center;  */
  /* text-align: center; */
}
.hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-content {
  width: 100%;
  /* padding-left: clamp(20px, 10vw, 200px);  */
  padding: 0% 10% 0% 10%; /* margen izquierdo fluido */
  white-space: nowrap; /* 🚫 nunca hace wrap */
}

.hero-content h1,
.hero-content p {
  white-space: nowrap; /* se aplica también a cada elemento de texto */
}
.hero-text {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
/* este es el que se mueve */
.parallax-wrapper {
  position: absolute;
  inset: 0;
}

/* el video no se toca */
.parallax-wrapper video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/*  */
.idiomas {
  position: absolute;
  /* top: 20px; */
  /* right: 30px; */
  display: inline-flex;
  background: #fff;
  border-radius: 15px;
  overflow: hidden;
  z-index: 3;
  margin-right: 3%;
}

.idioma {
  background: transparent;
  border: none;
  color: grey;
  font-weight: 600;
  padding: 5px 15px;
  cursor: pointer;
  transition: 0.3s;
  font-family: 'MONTSERRAT-WHT';
}
.idioma:hover {
  background: #d35915;
  border: none;
  color: white;
  font-weight: 600;
  padding: 5px 15px;
  cursor: pointer;
  transition: 0.3s;
  font-family: 'MONTSERRAT-WHT';
}
.idioma:focus {
  background: #d35915;
  border: none;
  color: white;
  font-weight: 600;
  padding: 5px 15px;
  cursor: pointer;
  transition: 0.3s;
  font-family: 'MONTSERRAT-WHT';
}
.el-dialog__headerbtn .el-dialog__close {
  color: #000;
  position: absolute;
  right: -57px;
  font-size: 22px;
  top: -36px;
  background: #fff;
  border-radius: 50%;
  padding: 6px;
  font-weight: bolder;
}
.el-dialog__header {
  padding: 0px;
}
.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 5px;
}
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.principal-video {
  height: calc(150vh - 0px);
}
.subtitulo_ {
  /* font-size: 1.5rem; */
  font-size: 1.5rem;
  color: #fff;
  margin-top: 0px;
  margin-right: 20%;
  font-family: 'roboto-regular';
  letter-spacing: 1.1px;
  line-height: 1.2;
}
.stylo_padding {
  /* padding: 20% 15% 20% 15%; */
}

.menuh > ul {
  position: absolute;
  right: 100px;
  top: 220px;
  list-style: none;
}
.menuh > ul > li {
  padding-bottom: 30px;
  transition: 0.2s all;
  cursor: pointer;
}
.menuh > ul > li:hover {
  transform: scale(1.1);
}
.menuh > ul > li > span {
  visibility: hidden;
}
.menuh > ul > li > span:hover {
  visibility: visible;
  color: #fff;
}
.menuh > ul > li > a {
  text-decoration: none;
}
.menuh > ul > li > a > i {
  border: 1px solid #fff;
  padding: 12px;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 12px;
}

.video {
  margin-top: 50px;
  display: block;
  color: #fff;
  font-size: 18px;
  font-style: italic;
  font-weight: 300;
}
.titulo_ {
  /* font-size: 3.5rem; */
  font-size: 83px;
  color: #fff;
  font-weight: 300 !important;
  /* //   margin: 100px; */
  line-height: 1.7;
  /* // margin-top: 200px; */
  margin-bottom: 0px;
  margin-top: 0%;
  margin-left: 0px !important;
  font-family: 'roboto-black';
  letter-spacing: 3px;
}

.titulo_ > h1 {
  font-weight: 300 !important;
}
@media (min-width: 2500px) {
  .titulo_ {
    font-size: 82px;
  }
  .subtitulo_ {
    font-size: 27px;
    color: #fff;
    margin-top: -15px;
    margin-right: 1.5rem;
    font-family: 'roboto-regular';
  }
  .stylo_padding {
    padding: 20% 45% 20% 0%;
  }
}

@media screen and (min-width: 1920px) and (max-width: 2000px) {
  .titulo_ {
    font-size: 82px;
    line-height: 1.5 !important;
  }
  .subtitulo_ {
    font-size: 27px;
    color: #fff;
    margin-top: -15px;
    margin-right: 1.5rem;
    font-family: 'roboto-regular';
    /* margin-bottom: 15px; */
    line-height: 1.2;
  }
  .stylo_padding {
    padding: 20% 23.5% 20% 0%;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .titulo_ {
    /* font-size: 3.2rem; */
    font-size: 74px;
    line-height: 1.5 !important;
  }
  .subtitulo_ {
    font-size: 24px;
    margin-right: 0%;

    margin-bottom: 5px;
  }
  .stylo_padding {
    padding: 20% 22% 20% 0%;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .titulo_ {
    /* font-size: 3.2rem; */
    font-size: 66px;
  }
  .subtitulo_ {
    font-size: 19px;
    margin-right: 0px;
    margin-bottom: 5px;
  }
  .stylo_padding {
    padding: 20% 22% 20% 0%;
  }
  .hero-content {
    width: 100%;
    /* padding-left: clamp(20px, 10vw, 200px);  */
    padding: 0% 0% 0% 10%; /* margen izquierdo fluido */
    white-space: nowrap; /* 🚫 nunca hace wrap */
  }
}
@media (orientation: portrait) {
  /* TABLES */
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .titulo_ {
      /* font-size: 3.2rem; */
      font-size: 53px;
    }
    .subtitulo_ {
      font-size: 18px;
      margin-right: 0px;

      margin-bottom: 5px;
    }
    .stylo_padding {
      padding: 20% 10% 20% 10%;
    }
    .principal-video,
    .hero {
      height: calc(80vh - 0px) !important;
    }
  }
  /* 📱 Celulares medianos (iPhone 6: 375–667) */
  @media screen and (min-width: 412px) and (max-width: 915px) {
    .titulo_ {
      /* font-size: 3.2rem; */
      font-size: 41px;
    }
    .subtitulo_ {
      font-size: 14px;
    }
    .stylo_padding {
      padding: 0% 0px 0px 10%;
    }
  }

  @media screen and (min-width: 428px) and (max-width: 932px) {
    .titulo_ {
      /* font-size: 3.2rem; */
      font-size: 50px;
    }
    .subtitulo_ {
      font-size: 25px;
      margin-top: 10px;
    }
    .stylo_padding {
      padding: 40% 0px 0px 10%;
    }
    .video-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 85%;
      position: absolute;
      overflow: hidden;
      z-index: 0;
    }
    .vue-responsive-videobg {
      background: none;
      position: relative;
      width: 100%;
      overflow: hidden;
      height: 70vh !important;
    }
    .principal-video,
    .hero {
      height: calc(95vh - 0px);
    }
  }

  @media screen and (min-width: 375px) and (max-width: 767px) {
    .titulo_ {
      /* font-size: 3.2rem; */
      font-size: 45px;
      margin-top: 10%;
      margin-right: 0%;
      letter-spacing: 2px;
      line-height: 1.1;
      margin-bottom: 20px;
    }
    .subtitulo_ {
      font-size: 20px;
      margin-top: 20px;
      letter-spacing: 1px;
      line-height: 1.3;
    }
    .stylo_padding {
      /* padding: 40% 0px 0px 15%; */
      padding: 45% 0% 30% 10%;
      /* padding: 50vh 10% 50vh 15%; */
      /* align-items: center; */
      display: flex;
      align-items: center;
    }
    .video-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 85%;
      position: absolute;
      overflow: hidden;
      z-index: 0;
    }
    .vue-responsive-videobg {
      background: none;
      position: relative;
      width: 100%;
      overflow: hidden;
      height: 100vh;
      align-items: center;
    }
    .principal-video,
    .hero {
      height: calc(75vh - 0px);
    }
  }

  /* 📱 Celulares chicos (como iPhone 5: 320–568) */
  @media screen and (max-width: 374px) {
    /* Estilos para celulares */
    .titulo_ {
      font-size: 45px;
      /* color: #fff; */
      /* font-weight: 300 !important; */
      /* margin: 30px; */
      /* line-height: 1.3; */
      margin-top: 10%;
      /* text-align: center; */
      font-family: 'roboto-black';
      margin-right: 0px;
      letter-spacing: 2px;
      line-height: 1.2;
      margin-bottom: 20px;
    }
    .principal-video,
    .hero {
      height: calc(80vh - 0px);
    }
    .subtitulo_ {
      font-size: 20px;
      margin-top: 10px;
      margin-right: 1rem;
      letter-spacing: 1px;
      line-height: 1.3;
    }
    .stylo_padding {
      /* padding: 40% 0px 0px 15%; */
      padding: 40% 5% 15% 10%;
      /* padding: 50vh 10% 50vh 15%; */
      /* align-items: center; */
      display: flex;
      align-items: center;
    }
  }
}
@media (orientation: landscape) and (max-height: 450px) {
  /* estilos para celular horizontal */
  .hero {
    position: relative;
    height: calc(120vh - 0px);
    overflow: hidden;
    display: flex;
    align-items: center;
    min-height: 60vh;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    /* text-align: center; */
  }
  .vue-responsive-videobg {
    background: none;
    position: relative;
    width: 100%;
    overflow: hidden;
    height: 115vh !important;
  }
  .titulo_ {
    /* font-size: 3.2rem; */
    font-size: 41px;
    line-height: 1;
    margin-bottom: 10px;
  }
  .subtitulo_ {
    font-size: 20px;
  }
  .stylo_padding {
    padding: 15% 0px 0px 10%;
  }
}

@media screen and (max-width: 1024px) {
  .el-dialog__headerbtn .el-dialog__close {
    color: #000;
    position: absolute;
    right: -20px;
    left: auto;
    font-size: 22px;
    top: -56px;
    background: #fff;
    border-radius: 50%;
    padding: 6px;
    font-weight: bolder;
  }
  /* .stylo_padding {
    padding: 0px 0px 0px 13%;
  } */
}

.btn-lenguaje {
  font-weight: 700;
  color: #00000082;
  border: none;
  background-color: white;
}
</style>
